import { typedSchema } from "@/shared/helpers/zod";
import { boolean, object, string, ZodIssueCode } from "zod";
import ENV from "../env";
import type { AuthTranslationKey } from "../services/culture/auth.translations";

export interface RegisterData {
  Password: string;
  ConfirmPassword: string;
  MfaEnabled: boolean;
  MfaCode?: string;
  AcceptedTermsOfService: boolean;
  AcceptedPrivacyPolicy: boolean;
}

const asRegisterSchema = typedSchema<RegisterData>();

export const createRegisterSchema = (t: (key: AuthTranslationKey) => string) =>
  asRegisterSchema(
    object({
      Password: string().min(8, t("validation.register.passwordMin")),
      ConfirmPassword: string().min(1, t("validation.register.confirmPasswordRequired")),
      MfaEnabled: boolean().default(false),
      MfaCode: string().optional(),
      AcceptedTermsOfService: boolean().default(false),
      AcceptedPrivacyPolicy: boolean().default(false),
    }).superRefine((data, ctx) => {
      if (data.ConfirmPassword !== data.Password) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: t("validation.register.passwordsDoNotMatch"),
          path: ["ConfirmPassword"],
        });
      }

      if (ENV.TERMS_AND_CONDITIONS_URL && data.AcceptedTermsOfService !== true) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: t("validation.register.acceptTermsOfUseRequired"),
          path: ["AcceptedTermsOfService"],
        });
      }

      if (ENV.PRIVACY_POLICY_URL && data.AcceptedPrivacyPolicy !== true) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: t("validation.register.acceptPrivacyPolicyRequired"),
          path: ["AcceptedPrivacyPolicy"],
        });
      }
    }),
  );
